import React from 'react';

import {
  BottomNavigation,
  BottomNavigationAction,
  Slide,
  useScrollTrigger,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import LocalizedLink from '@src/components/LocalizedLink';
import AboutIcon from '@src/icons/AboutIcon';
import ContactIcon from '@src/icons/ContactIcon';
import PartnersIcon from '@src/icons/PartnersIcon';
import StoriesIcon from '@src/icons/StoriesIcon';

const classes = {
  root: 'navbar-root',
  action: 'navbar-action',
  selectedAction: 'navbar-selected-action',
};

const NavbarRoot = styled(BottomNavigation)(({ theme }) => ({
  '&.navbar-root': {
    bottom: 0,
    boxShadow: theme.shadows[1],
    height: 'auto',
    left: 0,
    margin: 0,
    position: 'fixed',
    right: 0,
    top: 'auto',
    transition: `all ${theme.transitions.duration.standard}ms !important`,
    zIndex: theme.zIndex.appBar,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  '& .navbar-action': {
    color: theme.palette.secondary.main,
  },
  '& .navbar-selected-action': {
    color: theme.palette.text.primary,
    '& *': {
      color: theme.palette.text.primary,
    },
  },
}));

export default function Navbar({ location, ...props }) {
  const trigger = useScrollTrigger();

  const { locale = 'en', menu = [] } = props.pageContext;
  const menuItems = menu[locale];

  const icons = {
    about: <AboutIcon />,
    contact: <ContactIcon />,
    partners: <PartnersIcon />,
    stories: <StoriesIcon />,
  };

  return (
    <Slide appear={false} direction="up" in={!trigger}>
      <NavbarRoot className={classes.root} component="nav" showLabels>
        {menuItems?.map(({ icon, slug, title }) => (
          <BottomNavigationAction
            classes={{
              root: classes.action,
              selected: classes.selectedAction,
            }}
            component={LocalizedLink}
            key={slug}
            label={title}
            icon={icons[icon]}
            to={`${locale === 'en' ? '' : `/${locale}`}/${slug}`}
            underline="none"
            value={slug}
          />
        ))}
      </NavbarRoot>
    </Slide>
  );
}
